<template>
	<app-page>
		<app-heading :title="isNew ? 'New Enterprise' : enterprise.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'studeo-enterprises' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Studeo ID"
					v-model="enterprise.studeo_id"
					:errors="errors.studeo_id"
					:readonly="!isNew"
					required
				/>
				<input-text
					label="Name"
					v-model="enterprise.name"
					:readonly="!isNew"
					:errors="errors.name"
				/>
				<input-text
					label="Slug"
					v-model="enterprise.slug"
					:readonly="!isNew"
					:errors="errors.slug"
				/>
				<input-text
					label="Connection profile slug"
					v-model="enterprise.connection_profile_slug"
					:errors="errors.connection_profile_slug"
				/>
				<input-select
					label="Status"
					v-model="enterprise.active"
					:items="statuses"
					:errors="errors.active"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		try {
			if (!this.isNew) {
				this.$store.dispatch('app/startLoading')
				const enterprise = await this.$ravello.request()
					.v(2)
					.to('enterprises')
					.to(this.id)
					.get()

				this.enterprise = {
					studeo_id: enterprise.studeo_id,
					name: enterprise.name,
					slug: enterprise.slug,
					connection_profile_slug: enterprise.connection_profile_slug,
					active: enterprise.active,
				}
				this.$store.dispatch('app/stopLoading')
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
	},
	data() {
		return {
			enterprise: {
				studeo_id: 0,
				name: '',
				slug: '',
				connection_profile_slug: '',
				active: true,
			},
			errors: {},
			statuses: [{
				text: 'Active',
				value: true,
			}, {
				text: 'Inactive',
				value: false,
			}],
		}
	},
	computed: {
		id() {
			return this.$route.params.enterprise
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to('enterprises')
						.create(this.enterprise)
				} else {
					await this.$ravello.request()
						.v(2)
						.to('enterprises')
						.to(this.id)
						.update(this.enterprise)
				}

				this.$store.dispatch('app/stopLoading')
				this.$router.push({ name: 'studeo-enterprises' })
				this.$notifications.pushAlert('success', `Enterprise successfully ${this.isNew ? 'added' : 'updated'}`)
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}

				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
